import { useState, useEffect, useCallback } from "react";
import ListAvaliacao from "../Lists/ListAvaliacao/ListAvaliacao";
import moment from "moment/moment";
import { useContext } from "react";
import { AuthContext } from "../../../../../shared/context/auth-context";
import ModalVerAvaliacao from "./components/ModalVerAvaliacao";

import "./AvaliacoesComponent.scss";
import toast from "react-hot-toast";
import { useLoading } from "../../../../../shared/context/LoadingContext";
import { ClinicaContext } from "../../../../../shared/context/clinica-context";

function AvaliacoesComponent({ clienteId, sendRequest, token }) {
  const { startLoading, stopLoading } = useLoading();
  const [avaliacoes, setAvaliacoes] = useState([]);
  const [openModalAvaliacao, setOpenModalAvaliacao] = useState(false);
  const [modalVerAvaliacaoData, setModalVerAvaliacaoData] = useState();
  const auth = useContext(AuthContext);
  const clinica = useContext(ClinicaContext);

  const handleCloseModalAvaliacao = () => {
    setOpenModalAvaliacao(false);
    setModalVerAvaliacaoData(null);
  };
  ///////////////////////////////////////

  useEffect(() => {
    const fetchAvaliacoesByCliente = async () => {
      startLoading();
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/avaliacoes/cliente/comtratamento/${clienteId}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          }
        );

        const temp = responseData.avaliacoes.sort((a, b) => {
          return new Date(b.created_at) - new Date(a.created_at);
        });

        const avaliacoes_com_data_avaliacao = temp.map((avaliacao) => {
          const data_avaliacao = moment(avaliacao.created_at).format(
            "DD-MM-YYYY"
          );
          return (avaliacao = {
            ...avaliacao,
            data_avaliacao: data_avaliacao,
          });
        });

        //Filtrando por medico conforme o usuario
        //DEPOIS VERIFICAR OUTROS USUARIOS
        let tempAvaliacoes = [];

        // if (auth.role === "Médico/Administrador" || auth.role === "Dentista") {
        //   tempAvaliacoes = avaliacoes_com_data_avaliacao.filter(
        //     (av) => av.medico_responsavel.id === auth.userId
        //   );
        // } else
        if (auth.role === "Secretária(o)" || auth.role === "Assistente") {
          avaliacoes_com_data_avaliacao.forEach((av) => {
            auth.usuariosAssociados.forEach((medico) => {
              if (medico.id === av.medico_responsavel.id)
                tempAvaliacoes.push(av);
            });
          });
        } else {
          tempAvaliacoes = [...avaliacoes_com_data_avaliacao];
        }
        setAvaliacoes(tempAvaliacoes);
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    };
    fetchAvaliacoesByCliente();
  }, [sendRequest, clienteId, auth]);

  const handleDesativar = useCallback(
    async (id) => {
      startLoading();
      try {
        const formDataAvaliacao = new FormData();
        formDataAvaliacao.append("utilizador", auth.userId);
        const response = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/avaliacoes/toggleativo/${id}`,
          "PATCH",
          formDataAvaliacao,
          {
            Authorization: "Bearer " + token,
          }
        );
        let tempUpdatedAvaliacoes = avaliacoes.filter((el) => el.id !== id);
        setAvaliacoes(tempUpdatedAvaliacoes);

        toast.success(response.message);
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    },
    [avaliacoes, token, sendRequest]
  );

  const handleFecharAbrir = useCallback(
    async (id) => {
      startLoading();
      try {
        const formData = new FormData();
        formData.append("utilizador", auth.userId);
        await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/avaliacoes/fecharabrir/${id}`,
          "PATCH",
          formData,
          {
            Authorization: "Bearer " + token,
          }
        );
        let avalSelecionada;
        let tempUpdatedAvaliacoes = avaliacoes.map((el) => {
          if (el.id === id) {
            avalSelecionada = { ...el };
            return {
              ...el,
              fechado:
                el.fechado === undefined || el.fechado === false ? true : false,
            };
          } else {
            return el;
          }
        });
        setAvaliacoes(tempUpdatedAvaliacoes);
        toast.success(
          avalSelecionada.fechado === undefined ||
            avalSelecionada.fechado === false
            ? "Avaliação fechada com sucesso!"
            : "Avaliação aberta com sucesso!"
        );
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    },
    [avaliacoes, token, sendRequest]
  );

  const handleLancarDebito = useCallback(
    async (id) => {
      const filteredAvaliacao = avaliacoes.find((av) => av._id === id);
      startLoading();
      try {
        const [categoriasResponse, caixasResponse] = await Promise.all([
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/categoriasfinanceiro/clinica/entrada/${clinica.clinica._id}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token }
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/caixas/clinica/${clinica.clinica._id}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token }
          ),
        ]);

        const tempCaixa = caixasResponse.caixas.find(
          (c) => c.caixa === "Clínica"
        );
        const tempCategoriaFinanceiro =
          categoriasResponse.categoriasFinanceiro.find(
            (c) => c.categoria === "Avaliação"
          );

        try {
          if (
            clinica.clinica.configuracoes.configuracoes.avaliacao.ativo &&
            clinica.clinica.configuracoes.configuracoes.avaliacao.preco > 0
          ) {
            const formData4 = new FormData();
            formData4.append("tipo", "reembolso");
            formData4.append("clinica", clinica.clinica._id);
            formData4.append("observacoes", "");
            formData4.append(
              "valor",
              clinica.clinica.configuracoes.configuracoes.avaliacao.preco
            );
            formData4.append(
              "descricao",
              `Avaliação Odontológica nr ${filteredAvaliacao.numero}`
            );
            formData4.append("dataLimitePagamento", new Date());
            formData4.append("criadoPor", auth.userId);

            formData4.append("categoria", tempCategoriaFinanceiro._id);
            formData4.append("caixa", tempCaixa._id);
            formData4.append("cliente", clienteId);
            formData4.append("entradaRecebida", false);
            formData4.append("avaliacao", id);
            const entradaRetornada = await sendRequest(
              `${process.env.REACT_APP_BACKEND_LINK}/api/entradas`,
              "POST",
              formData4,
              {
                Authorization: "Bearer " + auth.token,
              }
            );

            const formDataDebito = new FormData();
            formDataDebito.append("entradaId", entradaRetornada.entrada._id);
            formDataDebito.append("utilizador", auth.userId);
            await sendRequest(
              `${process.env.REACT_APP_BACKEND_LINK}/api/avaliacoes/lancaremdebito/${id}`,
              "PATCH",
              formDataDebito,
              {
                Authorization: "Bearer " + token,
              }
            );
          }
        } catch (err) {
          console.error("err", err);
        }

        let tempUpdatedAvaliacoes = avaliacoes.map((el) => {
          if (el.id === id) {
            return {
              ...el,
              debitado: true,
            };
          } else {
            return el;
          }
        });
        setAvaliacoes(tempUpdatedAvaliacoes);
        toast.success("Valor da avaliação lançada em débito com sucesso!");
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    },
    [avaliacoes, token, sendRequest]
  );

  const handleOpenModalAvaliacao = (idAvaliacao) => {
    const tempAvaliacao = avaliacoes.find((av) => av.id === idAvaliacao);
    setModalVerAvaliacaoData(tempAvaliacao);
    setOpenModalAvaliacao(true);
  };

  return (
    <>
      <ModalVerAvaliacao
        open={openModalAvaliacao}
        handleClose={handleCloseModalAvaliacao}
        data={modalVerAvaliacaoData}
      />
      {avaliacoes.length !== 0 && (
        <>
          <ListAvaliacao
            data={avaliacoes}
            handleDesativar={handleDesativar}
            handleOpenModalAvaliacao={handleOpenModalAvaliacao}
            handleFecharAbrir={handleFecharAbrir}
            handleLancarDebito={handleLancarDebito}
            auth={auth}
          />
        </>
      )}
      {avaliacoes.length === 0 && (
        <div className="no_data_div">Nenhuma Avaliação encontrada.</div>
      )}
    </>
  );
}

export default AvaliacoesComponent;
